<template>
<div class="job-photo-uploader">
	<upload-field
		style-type="box"
		icon="fa-camera"
		target="LibraryUpload/save"
		accept="images"
		upload-msg="Take Photo"
		v-on:uploaded="photoUploaded">
	</upload-field>

	<job-file-upload-modal
		:visible="uploadModal.visible"
		:title="uploadModal.title"
		:record="uploadModal.record"
		:job-id="jobId"
		:is-edit="true"
		:store-location="storeLocation"
		:store-location-map="storeLocationMap"
		v-on:closeModal="closeFileModal"
		v-on:modelChanged="$emit('modelChanged', $event)">
	</job-file-upload-modal>
</div>
</template>

<script>
import UploadField from "@/components/UploadField"
import JobFileUploadModal from "@/components/super_components/JobFileUploadModal"

export default {
	name: "JobPhotoUploader",
	components: {
		UploadField,
		JobFileUploadModal
	},
	props: ["storeLocation", "jobId"],
	data() {
		return {
			uploadModal: {
				visible: false,
				title: "Edit file details",
				record: null
			},
			storeLocationMap: {
				project: {
					apiResource: "JobFile",
					jobField: "job_id",
					tagFilterField: "is_for_projects",
					recordTypeLabel: "Project"
				},
				service: {
					apiResource: "ServiceFile",
					jobField: "service_id",
					tagFilterField: "is_for_services",
					recordTypeLabel: "Service"
				}
			}
		}
	},
	methods: {
		photoUploaded(response) {
			let vm = this
			let locationConfig = this.storeLocationMap[this.storeLocation]

			let payload = {
				file_id: response.data.id
			}
			payload[locationConfig.jobField] = this.jobId

			this.postData(locationConfig.apiResource + "/save", payload, true).then(saveResponse => {
				if (saveResponse.success) {
					let uploadFile = response.data
					if (!("sharing_on" in uploadFile))
						uploadFile.sharing_on = 0

					vm.uploadModal.record = {
						id: saveResponse.data.record_id,
						file_id: response.data.id,
						filename: response.data.original_filename,
						caption: "",
						UploadFile: uploadFile,
						FileTag: []
					}
					vm.uploadModal.visible = true
					vm.$emit("modelChanged", {file_id: response.data.id})
				}
			})
		},
		closeFileModal() {
			this.uploadModal.visible = false
			this.uploadModal.record = null
		}
	}
}
</script>
